import { motion } from "framer-motion";

const steps = [
  {
    number: "01",
    title: "Заявка",
    description: "Оставьте заявку на сайте или свяжитесь с нами в Telegram",
  },
  {
    number: "02",
    title: "Подбор",
    description: "Найдём автомобиль по вашим критериям и проверим его состояние",
  },
  {
    number: "03",
    title: "Покупка",
    description: "Выкупим автомобиль после вашего одобрения и предоплаты",
  },
  {
    number: "04",
    title: "Доставка",
    description: "Организуем логистику морем или автотранспортом",
  },
  {
    number: "05",
    title: "Оформление",
    description: "Растаможка, сертификация и регистрация в ГАИ",
  },
];

export default function HowItWorksSection() {
  return (
    <section 
      id="how-it-works" 
      className="py-24 bg-[#0F0F0F] relative overflow-hidden"
      data-testid="how-it-works-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mb-4">
            Процесс
          </p>
          <h2 className="text-3xl md:text-5xl text-white font-normal">
            Как это работает
          </h2>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="relative group bg-[#1A1A1A] border border-white/10 p-6 hover:border-white/30 transition-colors"
              data-testid={`step-${index}`}
            >
              {/* Number */}
              <div className="flex items-center gap-3 mb-4">
                <span className="text-3xl font-bold text-white/80">
                  {step.number}
                </span>
                {index < steps.length - 1 && (
                  <div className="hidden md:block flex-1 h-px bg-white/20" />
                )}
              </div>
              
              {/* Content */}
              <h3 className="text-white text-base font-semibold mb-2">
                {step.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
